export default "__VITE_ASSET__Dpl0hZeH__"